import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Check = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.784 23.5239L4.80893 16.5269C4.41893 16.1359 4.42 15.5029 4.811 15.1129L5.56601 14.3609C5.95701 13.9709 6.58995 13.9719 6.97995 14.3629L11.878 19.2769C12.257 19.6569 12.8669 19.6699 13.2619 19.3079L25.086 8.4569C25.493 8.0839 26.126 8.1109 26.499 8.5179L27.219 9.3029C27.592 9.7099 27.5649 10.3419 27.1579 10.7159L13.167 23.5559C12.773 23.9169 12.162 23.9039 11.784 23.5239Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Check
